import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIcon } from "@angular/material/icon";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { TermsPageViewComponent } from "../../terms-page-view/terms-page-view.component";
import OktaAuth from "@okta/okta-auth-js";
import { OKTA_AUTH } from "node_modules/@okta/okta-angular/okta/models/okta.config";
import { FooterNameUrlEnum } from "src/app/shared/common/common.enum";

@Component({
  selector: "app-footer",
  imports: [CommonModule, MatDialogModule],
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.css",
})
export class FooterComponent {
  loading = false;
  @Input() isMobile = false;
  link = FooterNameUrlEnum;
  @Output() openTermsDialog = new EventEmitter<boolean>(false);
  private dialog = inject(MatDialog);

  onOpenTermsPopup() {
    this.openTermsDialog.emit(true);
  }
}
